/**
 * Crée un Work + Agent + Contribution + Expression + Manifestation
 * pour les items de type 'Autre' (CD, DVD, Jeux de société, etc.)
 *
 * @param {string} API_BASE
 * @param {string} token JWT (Authorization)
 * @param {Object} data
 */
async function createOther(API_BASE, token, data) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  const workRes = await fetch(`${API_BASE}/works/other`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });

  if (!workRes.ok) {
    throw new Error("Erreur création Autre: " + (await workRes.text()));
  }
  const work = await workRes.json();

  return {
    work,
  };
}

export default createOther;
